import { call, put, takeEvery } from "redux-saga/effects";
import { phongHocApi } from "../../../api/category/phongHocApi";
import { IPhongHoc } from "../../../model/respone/category/IPhongHoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  ePhongHocActionIds,
  IPhongHocActionTypes,
} from "../../action-types/category/IPhongHocActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";

const mainAction = rootActions.category.phongHoc;

export function* phongHocSaga(): any {
  yield takeEvery(ePhongHocActionIds.LOAD_START, loadWorker);
  yield takeEvery(ePhongHocActionIds.SAVE_START, saveWorker);
  yield takeEvery(ePhongHocActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(phongHocApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IPhongHocActionTypes): any {
  let res: IBaseRespone = yield call(phongHocApi.SelectAll);
  const payload = action.payload as IPhongHoc;
  if (payload.id_phong > 0) {
    res = yield call(phongHocApi.Update, payload);
  } else {
    res = yield call(phongHocApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IPhongHocActionTypes): any {
  const res: IBaseRespone = yield call(
    phongHocApi.Deletes,
    action.payload as IIdsRequest
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
